import { render, staticRenderFns } from "./TimeIcon.vue?vue&type=template&id=5f54d55d&"
import script from "./TimeIcon.vue?vue&type=script&lang=js&"
export * from "./TimeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports